import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';

import HtmlViewer from 'components/HtmlViewer';
import { is1593 } from 'utils/func';
import HardProductFields from './HardProductFields';
import KPITable from './KPITable';
import SoftProductFields from './SoftProductFields';
import ResearchContributions from './ResearchContributions';

export default function ResearchResult({ data, general }) {
  // #region Data
  const { t } = useTranslation();
  // #endregion
  return (
    <div>
      <h4>{t('projectProposal.researchResult.viewLabel')}</h4>
      <h4>{t('projectProposal.researchResult.productAndResearchResultDes.label')}</h4>
      <SoftProductFields products={data?.softProducts} />
      <HardProductFields
        products={data?.hardProducts}
        qualityComparison={data?.qualityComparison}
      />
      <h4>{t('projectProposal.researchResult.kpis.label')}</h4>
      <KPITable kpis={data?.projectProposalResearchKpis} data={data} />
      {is1593(general?.template) && (
        <div className="mt-4">
          <h4 className="text-lg text-red-500">
            {t('projectProposal.researchResult.kpis.k9_details')}
          </h4>
          <HtmlViewer
            html={general?.k9Details ?? ''}
            className="border border-1 border-gray-300 p-4 border-round-lg bg-white"
          />
        </div>
      )}
      <ResearchContributions data={data} />
    </div>
  );
}

ResearchResult.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.object.isRequired,

  // eslint-disable-next-line react/forbid-prop-types
  general: PropTypes.object.isRequired,
};
